import Vue from 'vue';
import Vuex from 'vuex';
import login from './modules/login';
import general from './modules/general';
import notifier from "./modules/notifier";
import loader from "./modules/loader";

// Load Vuex
Vue.use(Vuex);

// Create store
export default new Vuex.Store({
  modules: {
    login,
    general,
    notifier,
    loader
  }
});